/**
 * File: apps/qbench-cp/reactapp/src/shared/constants/permissions.js
 *
 * Purpose: Generates the CRUD permission key strings used by RBAC access policies.
 *
 * Scope: Permission key generation for invoice, quotation, report, source, and project entities
 *     in the customer portal.
 *
 * Tags: customer-portal, portal-roles
 *
 * Overview: Builds a nested `{ create: { <resource>: 'resource:create' }, read: {...}, update:
 *     {...} }` object by combining a fixed list of supported `ResourceActions` (CREATE, READ,
 *     UPDATE — DELETE is defined but not included) with a fixed list of `EntityType` resources,
 *     lowercasing both sides to form `resource:action` string keys. The generated object is
 *     consumed by `shared/configs/rbac/accessPolicies.js` to reference required privileges.
 *
 * Exports: default export — the generated `{ create, read, update }` permissions object.
 */

import { EntityType } from './entityTypes';

const l = (str = '') => str.toLowerCase();
const ResourceActions = {
  CREATE: 'CREATE',
  READ: 'READ',
  UPDATE: 'UPDATE',
  DELETE: 'DELETE',
};

// Not all actions are available for now.
const actions = [
  ResourceActions.CREATE,
  ResourceActions.READ,
  ResourceActions.UPDATE,
];
const resources = [
  EntityType.INVOICE,
  EntityType.QUOTATION,
  EntityType.REPORT,
  EntityType.SOURCE,
  EntityType.PROJECT,
];

function createPermissions() {
  return Object.fromEntries(
    actions.map((action) => [
      l(action),
      Object.fromEntries(
        resources.map((resource) => [
          l(resource),
          `${l(resource)}:${l(action)}`,
        ]),
      ),
    ]),
  );
}

export default createPermissions();
